import { render } from "./DesktopNavigation.vue?vue&type=template&id=4a7cf337&scoped=true"
import script from "./DesktopNavigation.vue?vue&type=script&lang=js"
export * from "./DesktopNavigation.vue?vue&type=script&lang=js"

import "./DesktopNavigation.vue?vue&type=style&index=0&id=4a7cf337&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7cf337"]])

export default __exports__